<p-dropdown
    [options]="languages"
    [(ngModel)]="activeLanguage"
    optionLabel="name"
    [style]="{'width':'200px'}"
    placeholder="Select Language"
    (onChange)="translate($event?.value?.code)">
    <!-- Template for options -->
    <ng-template let-language pTemplate="item">
        <div class="language-option">
            <img [src]="language.flag" alt="{{language.code}}" class="flag-icon"/>
            <span>{{ language.name }}</span>
        </div>
    </ng-template>
    <!-- Template for selected value -->
    <ng-template let-language pTemplate="selectedItem">
        <div class="language-option">
            <img [src]="language.flag" alt="{{language.code}}" class="flag-icon"/>
            <span>{{ language.name }}</span>
        </div>
    </ng-template>
</p-dropdown>
